export default __webpack_public_path__ + "9d060ce65c8a91d38e218db97dd82463.woff";